export const defaultData = {
  maxDepth: 5,
  //isTitleVisible: true,
  visibleTasks: null,
  orientation: "horizontal",
  link_type: "diagonal",
  caption: null,
  enableCaption: false,
}

export { default as EditDataForm } from "./EditDataForm"
export { default as FragComponent } from "./FragComponent"
export { default as pageSplitter } from "./pageSplitter"
